import { Button as AntdButton, Button, Dropdown, Space } from "antd";
import groupImage from "././../Assets/Icons/Group.svg";
import Multiselect from "multiselect-react-dropdown";
import { useEffect } from "react";
import JobService from "../Service.js/jobService";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import tickIcon from "../Assets/Icons/tick.svg";
import cartIcon from "../Assets/Icons/cart.svg";
import FooterLayout from "../Components/FooterLayout";
import toast from "react-hot-toast";
import cartIcon2 from "../Assets/Icons/cart2.svg";
import { TbCurrencyRupee } from "react-icons/tb";
import { TiLocationArrowOutline } from "react-icons/ti";
import { LuGraduationCap } from "react-icons/lu";
import { MdOutlineWorkOutline } from "react-icons/md";
import { useRef } from "react";
import AuthService from "../Service.js/authService";
import { Modal } from "antd";
import EmployeeRefer from "./EmployeeRefer";
import recruiterIcon from "../Assets/Icons/Recruiter.png";
import aidynamicimage from "././../Assets/Icons/ai_dynamic.jpg";
import bigfiveimage from "././../Assets/Icons/bigfive_personality.jpg";
import arrowlogo from "././../Assets/Icons/arrowlogo.jpeg";
import {
  useGetInterviewTypeData,
  useInitiatePayment,
  useScheduleInterview,
} from "../Hooks/AssesmentHooks";
import { getNthdayDate } from "../Components/Utilities/util";
import { isEmpty } from "lodash";
import HireHubHeader from "./HireHubHeader";
import jwtEncode from "jwt-encode";
import HireHubLanding from "./HireHubLanding";

const Home = () => {
  const user_id = localStorage.getItem("candidate");
  const interview_type = localStorage.getItem("interview_type");
  const [maxHeight, setMaxHeight] = useState(0);
  const cardRefs = useRef([]);
  const navigate = useNavigate();
  const [searchString, setSearchString] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [open, setOpen] = useState(false);
  const [autofills, setAutoFills] = useState("");
  const [jobDetails, setJobDetails] = useState();
  const [selectedValue, setSelectedValue] = useState({
    skills: "",
    title: "",
    location: "",
  });
  const [logo, setLogo] = useState();
  const [isModalOpen, setModalOpen] = useState(false);
  const [jobId, setJobId] = useState();
  const currentUser = localStorage.getItem("candidate");
  const user = JSON.parse(currentUser)?.is_recruiter_staff;
  const [isOpen, setIsOpen] = useState(false);
  const [openedData, setOpenedData] = useState({});
  const [isPaymentModal, setIsPaymentModal] = useState(false);
  const multiselectRef = useRef(null);

  useEffect(() => {
    if (user_id && interview_type) {
      if (interview_type === "Master Your Interview") {
        // navigate("/hirehub-talent?type=Candidate resume assessment");
         navigate("/hirehub-role-picker");
      } else if (interview_type === "AI Persona Check") {
        navigate("/hirehub-talent");
      }
    }
  }, [interview_type]);
  // const {
  //   data: interviewTypesData,
  //   status: interviewTypesDataStatus,
  //   refetch: refetchinterviewTypeData,
  //   isLoading: loadingInterviewTypeData,
  //   isFetching: fetchingInterviewTypeData,
  // } = useGetInterviewTypeData({
  //   params: {},
  //   enabled: !!user_id,
  // });
  console.log(user_id, "!!user_id");
  const { mutate: scheduleInterview, isLoading: isScheduleInterviewLoading } =
    useScheduleInterview({
      onSuccess: (data) => {
        console.log(data, "dddaaattaaa");
        window.open(data?.link, "_blank");
      },
      onError: () => {
        // messageApi.open({
        //   type: 'error',
        //   content: DEFAULT_ERROR_MESSAGE,
        // });
      },
    });

  const { mutate: initiatePayment, isLoading: isInitialPaymentLoading } =
    useInitiatePayment({
      handleOnSuccess: (data) => {
        console.log(data, "dddaaattaaa");
        window.location.href = data?.redirectUrl;
      },
      onError: () => {
        // messageApi.open({
        //   type: 'error',
        //   content: DEFAULT_ERROR_MESSAGE,
        // });
      },
    });

  console.log("currentIser", user);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const jobList = async () => {
    await JobService.jobList()
      .then((response) => {
        setJobDetails(response?.data?.data);
      })
      .catch((err) => {});
  };
  console.log("jobDetails", jobDetails);
  useEffect(() => {
    jobList();
    getLogo();
  }, []);
  const getLogo = async () => {
    if (currentUser) {
      await AuthService.getCompanyLogoWithLogin()
        .then((oResponse) => {
          console.log("oResponse", oResponse.data.data);
          setLogo(oResponse.data.data);
          //setSingleSelectValue({...singleSelectValue, [id]:dropDownOPtions(oResponse.data.data.prescreen_fields)})
        })
        .catch((err) => err);
    } else {
      await AuthService.getCompanyLogoWithoutLogin()
        .then((oResponse) => {
          console.log("oResponse", oResponse?.data?.data);
          setLogo(oResponse.data.data);
          //setSingleSelectValue({...singleSelectValue, [id]:dropDownOPtions(oResponse.data.data.prescreen_fields)})
        })
        .catch((err) => err);
    }
  };

  const jobInfo = jobDetails?.results?.slice(0, 9);
  console.log("data", jobInfo);
  const candidateId = jobDetails?.results[0]?.candidate_id;
  const userId = jobDetails?.results[0]?.user_id;
  const handlesearch = async (serachValue) => {
    setSearchString(serachValue);
    await JobService.autofill(serachValue)
      .then((response) => {
        setAutoFills(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const truncateStrHandler = (str) => {
    return str.length > 10 ? str.substring(0, 5) + "..." : str;
  };
  const locationStrHandler = (str) => {
    return str?.length > 9 ? str.substring(0, 9) + "..." : str;
  };
  const handleChange = async () => {
    if (
      selectedValue.skills ||
      selectedValue.location ||
      selectedValue.title != ""
    ) {
      const skillsName = selectedValue.skills.map((i) => i.name).toString();
      const titleName = selectedValue.title.map((i) => i.name).toString();
      const locationName = selectedValue.location.map((i) => i.name).toString();
      await JobService.searchJob(skillsName, titleName, locationName)
        .then((response) => {
          setJobDetails(response.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      await JobService.searchJob(
        selectedValue.skills,
        selectedValue.title,
        selectedValue.location,
      )
        .then((response) => {
          setJobDetails(response.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const dropDownOPtions = (data) => {
    var options = [];
    for (var i = 0; i < data.length; i++) {
      options.push({
        id_alias: data[i].id_alias,
        name: data[i].name,
        type: data[i].type,
      });
    }
    return options;
  };

  const deleteCart = async (jobId) => {
    await JobService.deleteCart(jobId)
      .then((response) => {
        toast.success("Removed from BookMark");
        jobList();
      })
      .catch((error) => {
        toast.error("Failed To Add");
      });
  };
  const handleCart = async (jobId) => {
    await JobService.addToCart(jobId)
      .then((response) => {
        toast.success("Added To BookMark");
        jobList();
      })
      .catch((error) => {
        toast.error("Failed To Add");
      });
  };
  const handelRemove = (data) => {
    console.log("fsqy", data);
    if (data.length === 0) {
      jobList();
    }
  };
  const handleSerachSelect = (data) => {
    const skills = [];
    const titles = [];
    const locations = [];

    for (var i = 0; i < data.length; i++) {
      if (data[i].type == "skill") {
        skills.push({
          // id_alias: data[i].id_alias,
          name: data[i].name,
          // type: data[i].type
        });
      }
      if (data[i].type == "title") {
        titles.push({
          // id_alias: data[i].id_alias,
          name: data[i].name,
          // type: data[i].type
        });
      }
      if (data[i].type == "location") {
        locations.push({
          // id_alias: data[i].id_alias,
          name: data[i].name,
          // type: data[i].type
        });
      }

      setSelectedValue({ skills: skills, title: titles, location: locations });
    }
  };
  const handleReferCandidates = (job_id) => {
    setModalOpen(true);
    setJobId(job_id);
  };
  useEffect(() => {
    const calculateMaxHeight = () => {
      const heights = cardRefs.current
        .filter(Boolean)
        .map((ref) => ref?.offsetHeight || 0);
      const newMaxHeight = Math.max(...heights, 0);
      setMaxHeight(newMaxHeight);
    };

    // Run the calculation after initial render
    setTimeout(calculateMaxHeight, 100);

    // Recalculate on window resize
    window.addEventListener("resize", calculateMaxHeight);

    // Use MutationObserver to watch for DOM changes in the card container
    const container = document.querySelector(".job-card-container");
    let observer;
    if (container && window.MutationObserver) {
      observer = new MutationObserver(() => {
        setTimeout(calculateMaxHeight, 50);
      });
      observer.observe(container, { childList: true, subtree: true });
    }

    // Cleanup event listener and observer on component unmount
    return () => {
      window.removeEventListener("resize", calculateMaxHeight);
      if (observer) observer.disconnect();
    };
  }, [jobInfo]);
  const noDataMessage = "Not Mentioned";
  console.log("test", searchString);

  const handleClose = () => {
    setIsOpen(false);
    setIsPaymentModal(false);
  };

  // Proceed to payment success modal
  const handleProceed = async () => {
    const data = {
      company_interview_id: openedData?.company_interview_id,
    };
    await initiatePayment({ data });
    // setIsOpen(false);
    // setTimeout(() => setIsPaymentModal(true), 200);
  };

  const handleStartInterview = async (item) => {
    const now = new Date();
    const body = {
      candidates: [item?.candidate],
      interview_date_time_to: getNthdayDate(7),
      subject: "TEST",
      duration: "30",
    };

    await scheduleInterview({
      body,
      params: {},
    });
  };

  const handleFocus = () => {
    const input = multiselectRef.current?.querySelector("input");
    if (input) {
      input.focus();
    }
  };

  return (
    <>
      <div className="scrollbar-hide dark:bg-dark-secondaryBgMain ">
        <div className="">
          <div className=" pt-0 flex flex-col mx-auto px-4">
            <div className="w-full flex flex-col items-center justify-center mb-8">
              <div className="md:w-5/6 lg:w-5/6 1xl:w-5/6 xs-xl:w-5/6 2xl:w-4/6 sm:w-5/6 xs:w-5/6 flex items-center justify-end pt-6">
                <div className="">
                  {/* {currentUser === null ? (
                    <Link
                      to="/login"
                      className="text-[#0071DC] border border-[#0071DC] text-sm md:text-base px-3 md:px-5 py-1.5 md:py-2 rounded-md hover:text-white hover:bg-[#0071DC] transition duration-300 text-center mr-5 md:mr-0"
                    >
                      Sign In
                    </Link>
                  ) : (
                    <HireHubHeader />
                  )} */}
                  {currentUser && <HireHubHeader />}
                </div>
              </div>

              {/* <img
                src={arrowlogo}
                alt="AI HIRE Hub Logo"
                className="w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 object-contain"
              /> */}
            </div>
            {/* {currentUser === null ? (
              <HireHubLanding handleFocus={handleFocus} currentUser={currentUser} />
            ) : (
              <div className="w-full">
                <div className=" mx-auto flex flex-wrap  justify-center gap-8 full md:w-[80%]">
                  {isEmpty(interviewTypesData) ? (
                    <>
                      <div className="shadow-md hover:shadow-lg rounded-sm overflow-hidden bg-white w-full sm:w-[90%] md:w-[30%] p-3">
                        <img
                          src={aidynamicimage}
                          alt="Big Five Personality Test"
                          className="w-full h-80 object-cover"
                        />
                        <div className="p-4">
                          <h3 className="text-lg font-semibold mb-2">
                            Master Your Interview
                          </h3>
                          <p className="text-sm text-gray-600 mb-4">
                            AI Interview helps candidates instantly evaluate
                            their skills, identify strengths and gaps, and
                            prepare confidently for real job interviews with
                            data-driven feedback.
                          </p>
                          <div className="flex justify-between items-center">
                            <button
                              className="bg-[#0071DC] p-2 px-8 text-white font-bold rounded-md"
                              onClick={() => navigate("/login")}
                            >
                              Sign In
                            </button>
                            <p className="font-bold text-xl ">₹248</p>
                          </div>
                        </div>
                      </div>
                      <div className="shadow-md hover:shadow-lg rounded-sm overflow-hidden bg-white w-full sm:w-[90%] md:w-[30%] p-3">
                        <img
                          src={bigfiveimage}
                          alt="Big Five Personality Test"
                          className="w-full h-80 object-cover"
                        />
                        <div className="p-4">
                          <h3 className="text-lg font-semibold mb-2">
                            AI Persona check
                          </h3>
                          <p className="text-sm text-gray-600 mb-4">
                            AI Persona Check helps candidates understand their
                            personality traits, work style, and behavioural
                            strengths to align better with suitable job roles
                            and improve interview performance.
                          </p>
                          <div className="flex justify-between items-center">
                            <button
                              className="bg-[#0071DC] p-2 px-8 text-white font-bold rounded-md"
                              onClick={() => navigate("/login")}
                            >
                              Sign In
                            </button>
                            <p className="font-bold text-xl ">₹117</p>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    interviewTypesData?.interviews_payment_details?.map(
                      (item) => (
                        <div className="shadow-md hover:shadow-lg rounded-sm overflow-hidden bg-white w-full sm:w-[90%] md:w-[45%] p-3">
                          <img
                            src={
                              item?.interview_type ===
                              "Master Your Interview"
                                ? aidynamicimage
                                : bigfiveimage
                            }
                            alt="AI Dynamic Interview"
                            className="w-full h-80 object-cover"
                          />
                          <div className="p-4">
                            <h3 className="text-lg font-semibold mb-2">
                              {item?.label}
                            </h3>
                            <p className="text-sm text-gray-600 mb-4">
                              {item?.description}
                            </p>
                            <div className="flex justify-between items-center">
                              {item?.status === "UNPAID" ||
                              (item?.status === "PAID" &&
                                item?.attended_status) ? (
                                <button
                                  className="bg-[#0071DC] p-2 px-8 text-white font-bold rounded-md"
                                  onClick={() => {
                                    const token = jwtEncode(item, "");
                                    console.log(token, "token>>?");

                                    window.open(
                                      `https://hirehub.ipecsolutions.com/payment-checkout?token=${token}`,
                                      "_blank",
                                    );
                                  }}
                                >
                                  Pay Now
                                </button>
                              ) : (
                                <button
                                  className="bg-[#1229fa] p-2 px-8 text-white font-bold rounded-md"
                                  onClick={() =>
                                    window.open(item?.link, "_blank")
                                  }
                                >
                                  Start Interview
                                </button>
                              )}

                              <span className="font-bold text-xl">
                                ₹{item?.fee}
                              </span>
                            </div>
                          </div>
                        </div>
                      ),
                    )
                  )}

                  {isOpen && (
                    <div
                      className="fixed inset-0 flex items-center justify-center bg-black/50 z-50 px-4 sm:px-6"
                      onClick={() => setIsOpen(false)}
                    >
                      <div
                        className="bg-white w-full max-w-lg sm:max-w-xl rounded-2xl shadow-2xl p-6 sm:p-10 md:p-16 relative overflow-y-auto max-h-[90vh]"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-6 text-center sm:text-left">
                          Review & Confirm
                        </h2>

                        <div className="flex flex-col sm:flex-row items-center sm:items-start sm:gap-6 border p-4 rounded-lg bg-gray-50 mb-6">
                          <img
                            src={
                              openedData?.interview_type ===
                              "Master Your Interview"
                                ? aidynamicimage
                                : bigfiveimage
                            }
                            alt="Product"
                            className="w-24 h-24 object-cover rounded-md mb-4 sm:mb-0"
                          />
                          <div className="text-center sm:text-left">
                            <p className="font-medium text-gray-800 text-base">
                              {openedData?.interview_type}
                            </p>
                            <p className="text-[#0071DC] font-semibold text-lg">
                              ₹{openedData?.fee}
                            </p>
                          </div>
                        </div>

                        <div className="space-y-3 text-sm sm:text-base text-black mb-6">
                          <p className="flex justify-between">
                            <span className="font-medium text-gray-700 w-24">
                              Date
                            </span>
                            <span>{openedData?.date}</span>
                          </p>
                          <p className="flex justify-between">
                            <span className="font-medium text-gray-700 w-24">
                              Name
                            </span>
                            <span>{openedData?.candidate_name}</span>
                          </p>
                          <p className="flex justify-between">
                            <span className="font-medium text-gray-700 w-24">
                              Email
                            </span>
                            <span className="truncate max-w-[150px] sm:max-w-none text-right">
                              {openedData?.email}
                            </span>
                          </p>
                        </div>

                        <div className="flex justify-between items-center border-t pt-4 mb-6">
                          <span className="font-bold text-black text-base sm:text-lg">
                            Total Amount
                          </span>
                          <span className="font-bold text-lg text-[#0071DC]">
                            ₹{openedData?.fee}
                          </span>
                        </div>

                        <div className="flex flex-col sm:flex-row justify-end gap-3 sm:gap-4 mt-10 sm:mt-14">
                          <button
                            onClick={() => setIsOpen(false)}
                            className="w-full sm:w-auto px-5 py-2.5 border border-[#0071DC] rounded-md text-[#0071DC] hover:bg-gray-100 transition"
                          >
                            Cancel Payment
                          </button>
                          <button
                            className="w-full sm:w-auto px-5 py-2.5 bg-[#0071DC] text-white rounded-md font-medium hover:bg-[#005bb5] transition"
                            onClick={() => handleProceed()}
                            disabled={isInitialPaymentLoading}
                          >
                            Proceed to Checkout
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )} */}
            <HireHubLanding />
          </div>
          {/* <div className="mt-12 chart_div">
            <div className="w-1/2 ">
              <img src={groupImage} alt="grouimah" />
            </div>

            <div>
              <p className="font-bold md:text-5xl sm:text-xl item-center ">
                Find your job now !
              </p>
            </div>
            <div className="pt-7 md:w-3/6 sm:w-full" ref={multiselectRef}>
              <div className="relative">
                <Multiselect
                  className="md:pl-12"
                  options={dropDownOPtions(autofills)}
                  onSelect={handleSerachSelect}
                  onRemove={handelRemove}
                  displayValue="name"
                  onSearch={handlesearch}
                  placeholder="Enter skills / designation"
                />
                <Button
                  className="absolute px-10 right-3 top-3 custom-button "
                  onClick={handleChange}
                >
                  Search
                </Button>
              </div>
            </div>
            <div className="mt-24 md:w-5/6 lg:w-5/6 1xl:w-5/6 xs-xl:w-5/6 2xl:w-4/6 sm:w-5/6 xs:w-5/6 sm:mx-4 md:mx-0">
              <div className="">
                <div className="flex flex-row justify-between">
                  <div className="flex items-center">
                    <p className="text-2xl font-semibold xs:text-xl">
                      Recent jobs{" "}
                    </p>
                    <div className="p-1 mx-4 border border-[#EDE396] bg-[#FBF194] rounded-full ">
                      <p className="px-4 pt-1 text-sm font-semibold text-[#5E4418]">
                        {jobDetails?.count} new jobs
                      </p>
                    </div>
                  </div>
                  <div>
                    <Link to="/jobs">
                      <p className="underline">View All</p>
                    </Link>
                  </div>
                </div>
                <div className="flex-wrap md:flex md:flex-row sm:flex-col">
                  {jobInfo?.map((item, index) => {
                    const colors = ["#FFF"];
                    const locations = item.locations?.map((obj) => obj);
                    const educations = item?.education_details?.map(
                      (obj) => obj,
                    );
                    return (
                      <div className="px-2 mt-6 lg:w-1/2 xl:w-1/3 md:w-full sm:w-full xs:w-full sm:flex-col md:flex-row sm:px-2">
                        <div
                          className="p-3 border border-gray-300 cursor-pointer rounded-xl "
                          key={index}
                          ref={(el) => (cardRefs.current[index] = el)}
                          onClick={() => navigate(`/jobDetails/${item.id}`)}
                          style={{
                            backgroundColor: colors[index % colors.length],
                            height: maxHeight ? `${maxHeight}px` : "auto",
                          }}
                        >
                          <div className="px-6 text-left">
                            <div className="flex flex-row justify-between ">
                              {currentUser ? (
                                item.is_saved === false ? (
                                  <div className="pt-2">
                                    <button>
                                      <img
                                        alt="cart"
                                        src={cartIcon}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleCart(item.id);
                                        }}
                                      />
                                    </button>
                                  </div>
                                ) : (
                                  <div className="pt-2">
                                    <button>
                                      <img
                                        alt="cart"
                                        className=""
                                        src={cartIcon2}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          deleteCart(item.id);
                                        }}
                                      />
                                    </button>
                                  </div>
                                )
                              ) : (
                                ""
                              )}
                            </div>
                            <p className="font-sans text-sm mt-2">
                              {item?.client_name}
                            </p>
                            <Link to={`/jobDetails/${item.id}`}>
                              <button className="mt-2 text-base font-bold text-left">
                                {item?.title}
                              </button>
                            </Link>
                            <div className="mt-2">
                              <ul className="flex flex-wrap">
                                <li className="mb-2">
                                  <div className="flex flex-wrap">
                                    {item.experience != false && (
                                      <span className="flex flex-wrap items-center mr-3">
                                        <MdOutlineWorkOutline className="mr-2" />
                                        {item.experience}
                                      </span>
                                    )}
                                    {item.experience != false &&
                                      item.job_type && (
                                        <span className="mx-2 divider">|</span>
                                      )}
                                    {item.job_type && (
                                      <span className="flex items-center mr-4">
                                        <TiLocationArrowOutline className="mr-2 contentIcon" />
                                        {item.job_type}
                                      </span>
                                    )}
                                  </div>
                                </li>
                              </ul>
                              <ul className="flex flex-wrap ">
                                <li className="mb-4 ">
                                  <div className="">
                                    {item?.education_details.length > 0 && (
                                      <span className="flex flex-wrap items-center mr-4 ">
                                        <LuGraduationCap className="mr-2" />
                                        {educations.join(",")}
                                      </span>
                                    )}
                                    {item.salary_confidential === true ? (
                                      <span className="flex items-center mt-2">
                                        <TbCurrencyRupee className="mr-2 contentIcon" />
                                        <p>As per industry standards </p>
                                      </span>
                                    ) : (
                                      item.salary_details != false && (
                                        <span className="flex items-center mt-2">
                                          <TbCurrencyRupee className="mr-2 contentIcon" />
                                          {item.salary_details}
                                        </span>
                                      )
                                    )}
                                  </div>
                                </li>
                              </ul>
                            </div>

                            <div>
                              <p title={locations}>
                                {locationStrHandler(locations[0])}
                              </p>
                            </div>
                            <div className="pt-1 mt-2 bg-white rounded-xl">
                              <p>{item?.posted}</p>
                            </div>
                            <div className="flex justify-end">
                              {user == true && (
                                <div className="px-2">
                                  <Button
                                    className="rounded-full text-[#3E94EB] text-base font-semibold font-poppins border border-[#3E94EB] cursor-pointer"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleReferCandidates(item.id);
                                    }}
                                    type="text"
                                  >
                                    Refer now
                                  </Button>
                                </div>
                              )}
                              {item.current_status !== false && (
                                <div className="px-2">
                                  <p className="px-2 pt-[5px] text-[#1C4980] text-base font-semibold">
                                    {item.current_status}
                                  </p>
                                </div>
                              )}
                              {currentUser === null ? (
                                <div className="flex justify-end">
                                </div>
                              ) : item.applied === false ? (
                                <div className="flex flex-wrap justify-end">
                                  <div>
                                    <Button className="rounded-full text-white bg-[#1C4980] text-base font-semibold">
                                      <Link to={`/jobDetails/${item.id}`}>
                                        Apply
                                      </Link>
                                    </Button>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex justify-end py-1">
                                  <p className="px-2 text-[#1C4980] text-base font-semibold">
                                    Applied
                                  </p>
                                  <img
                                    src={tickIcon}
                                    alt="work"
                                    className="w-4 h-auto mr-3 contentIcon"
                                  />
                                </div>
                              )}
                              
                              <div>
                                <p className="rounded-full text-[#3E94EB] text-base font-semibold font-poppins cursor-pointer">
                                  Know More
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

               
              </div>
            </div>
            <div className="w-full mt-8"></div>
          </div> */}
        </div>
      </div>
      <Modal
        open={isModalOpen}
        title="Refer Your Friend"
        footer={null}
        width={700}
        onCancel={() => setModalOpen(false)}
        className=""
      >
        <div className="">
          <EmployeeRefer jobId={jobId} setModalOpen={setModalOpen} />
        </div>
      </Modal>
    </>
  );
  // return (
  //   <>
  //     <div className="pageContent scrollbar-hide j">
  //       <div className="flex items-center justify-center ">
  //         <div>
  //           <div>
  //             <img src={groupImage} alt="grouimah" />
  //           </div>
  //           <div className="flex items-center justify-center">
  //             <div>
  //               <p className="font-bold md:text-5xl sm:text-xl item-center sm:pl-20 md:pl-0 ">
  //                 Find your job now !
  //               </p>
  //             </div>
  //           </div>

  //           <div className="w-full pt-7 md:px-20">
  //             <div className="relative">
  //               <Multiselect
  //                 className="pl-12"
  //                 options={dropDownOPtions(autofills)} // Options to display in the dropdown
  //                 onSelect={handleSerachSelect} // Function will trigger on select event
  //                 onRemove={handelRemove} // Function will trigger on remove event
  //                 displayValue="name" // Property name to display in the dropdown options
  //                 onSearch={handlesearch}
  //                 placeholder="Enter skills / designations / location"
  //               />
  //               <Button
  //                 className="absolute px-10 right-3 top-3 custom-button "
  //                 onClick={handleChange}
  //               >
  //                 Search
  //               </Button>
  //             </div>
  //           </div>
  //           <div className="flex items-center justify-center">
  //             <div className="mt-24 md:mx-20 lg:mx-20 xl:mx-0 sm:px-10 xs:pl-10 xs:pr-6 ">
  //               <div className="">
  //                 <div className="flex flex-row justify-between">
  //                   <div className="flex ">
  //                     <p className="text-2xl font-semibold xs:text-xl">
  //                       Recent jobs{" "}
  //                     </p>

  //                     <div className="p-1 mx-4 border border-gray-400 rounded-full ">
  //                       <p className="px-4 pt-1 text-sm font-semibold">
  //                         {jobDetails?.count} new jobs
  //                       </p>
  //                     </div>
  //                   </div>
  //                   <div>
  //                     <Link to="/jobs">
  //                       <p className="underline">View All</p>
  //                     </Link>
  //                   </div>
  //                 </div>

  //                 <div className="flex-wrap md:flex md:flex-row sm:flex-col">
  //                   {jobInfo?.map((item, index) => {
  //                     // const colors = ["#DDFFF9", "#FFEBDD", "#EEDDFF", "#DDF3FF"];
  //                     const colors = ["#FFF"];
  //                     const locations = item.locations?.map((obj) => obj);
  //                     const educations = item?.education_details?.map(
  //                       (obj) => obj
  //                     );
  //                     return (
  //                       <div
  //                         // style={{ height: maxHeight ? `${maxHeight}px` : "auto" }}
  //                         className="px-2 mt-6 lg:w-1/2 xl:w-1/3 md:w-full sm:w-3/4 xs:w-full sm:flex-col md:flex-row sm:px-2"
  //                       >
  //                         <div className="p-3 border border-gray-300 rounded-md">
  //                           <div
  //                             key={index}
  //                             ref={(el) => (cardRefs.current[index] = el)}
  //                             onClick={() => navigate(`/jobDetails/${item.id}`)}
  //                             className="rounded-lg cursor-pointer"
  //                             style={{
  //                               backgroundColor: colors[index % colors.length],
  //                               height: maxHeight ? `${maxHeight}px` : "auto",
  //                             }}
  //                           >
  //                             <div className="px-6">
  //                               <div className="flex flex-row justify-between ">
  //                                 <div className="px-2 pt-1 mt-2 bg-white rounded-xl">
  //                                   <p>{item?.posted}</p>
  //                                 </div>
  //                                 {currentUser ? (
  //                                   item.is_saved === false ? (
  //                                     <div className="pt-2">
  //                                       <button>
  //                                         <img
  //                                           alt="cart"
  //                                           src={cartIcon}
  //                                           onClick={() => handleCart(item.id)}
  //                                         />
  //                                       </button>
  //                                     </div>
  //                                   ) : (
  //                                     <div className="pt-2">
  //                                       <button>
  //                                         <img
  //                                           alt="cart"
  //                                           className=""
  //                                           src={cartIcon2}
  //                                           onClick={() => deleteCart(item.id)}
  //                                         />
  //                                       </button>
  //                                     </div>
  //                                   )
  //                                 ) : (
  //                                   ""
  //                                 )}
  //                               </div>
  //                               <Link to={`/jobDetails/${item.id}`}>
  //                                 <button className="mt-2 text-base font-bold">
  //                                   {item?.title}
  //                                 </button>
  //                               </Link>
  //                             </div>
  //                             {/* <div className="flex flex-wrap pb-4 mt-2 ">
  //                           {item.required_skill
  //                             ?.slice(0, 2)
  //                             .map((skill, index) => (
  //                               <div
  //                                 key={index}
  //                                 className="p-1 mt-2 ml-4 border border-gray-400 rounded-3xl"
  //                               >
  //                                 <p
  //                                   className="px-2 pt-1 text-xs font-normal"
  //                                   title={skill}
  //                                 >
  //                                   {truncateStrHandler(skill)}
  //                                 </p>
  //                               </div>
  //                             ))}
  //                           {item.required_skill?.length > 2 && (
  //                             <div className="p-1 mt-2 cursor-pointer ">
  //                               <Link to={`/jobDetails/${item.id}`}>
  //                                 <p className="px-2 pt-1 text-xs font-normal text-gray-600">
  //                                   ...more
  //                                 </p>
  //                               </Link>
  //                             </div>
  //                           )}
  //                         </div> */}
  //                             <div className="pl-6 mt-2">
  //                               <ul className="flex flex-wrap">
  //                                 <li className="mb-2">
  //                                   <div className="flex flex-wrap">
  //                                     {item.experience != false && (
  //                                       <span className="flex flex-wrap items-center mr-3">
  //                                         <MdOutlineWorkOutline className="mr-2" />
  //                                         {item.experience}
  //                                       </span>
  //                                     )}
  //                                     {item.experience != false &&
  //                                       item.job_type && (
  //                                         <span className="mx-2 divider">
  //                                           |
  //                                         </span>
  //                                       )}
  //                                     {item.job_type && (
  //                                       <span className="flex items-center mr-4">
  //                                         <TiLocationArrowOutline className="mr-2 contentIcon" />
  //                                         {item.job_type}
  //                                       </span>
  //                                     )}
  //                                   </div>
  //                                 </li>
  //                               </ul>
  //                               <ul className="flex flex-wrap ">
  //                                 <li className="mb-4 ">
  //                                   <div className="">
  //                                     {item?.education_details.length > 0 && (
  //                                       <span className="flex flex-wrap items-center mr-4 ">
  //                                         <LuGraduationCap className="mr-2" />
  //                                         {educations.join(",")}
  //                                       </span>
  //                                     )}
  //                                     {item.salary_confidential === true ? (
  //                                       <span className="flex items-center mt-2">
  //                                         <TbCurrencyRupee className="mr-2 contentIcon" />
  //                                         <p>As per industry standards </p>
  //                                       </span>
  //                                     ) : (
  //                                       item.salary_details != false && (
  //                                         <span className="flex items-center mt-2">
  //                                           <TbCurrencyRupee className="mr-2 contentIcon" />
  //                                           {item.salary_details}
  //                                         </span>
  //                                       )
  //                                     )}
  //                                   </div>
  //                                 </li>
  //                               </ul>
  //                             </div>
  //                           </div>
  //                           <div className="flex flex-row flex-wrap justify-between mt-4">
  //                             <div>
  //                               <p title={locations}>
  //                                 {locationStrHandler(locations[0])}
  //                               </p>
  //                             </div>
  //                             <div>
  //                               {currentUser === null ? (
  //                                 <Button
  //                                   className="rounded-3xl text-white bg-[#0A0A0A]"
  //                                   onClick={showDrawer}
  //                                 >
  //                                   Login To Apply
  //                                 </Button>
  //                               ) : item.applied === false ? (
  //                                 <Button className="rounded-3xl text-white bg-[#0A0A0A]">
  //                                   <Link to={`/jobDetails/${item.id}`}>
  //                                     Apply
  //                                   </Link>
  //                                 </Button>
  //                               ) : (
  //                                 <div className="flex px-5 py-1">
  //                                   <p className="px-2 text-base font-medium text-green-600">
  //                                     Applied
  //                                   </p>
  //                                   <img
  //                                     src={tickIcon}
  //                                     alt="work"
  //                                     className="w-4 h-auto mr-3 contentIcon"
  //                                   />
  //                                 </div>
  //                               )}
  //                               {open && (
  //                                 <CandidateLogin
  //                                   open={open}
  //                                   onClose={onClose}
  //                                 />
  //                               )}
  //                             </div>
  //                           </div>
  //                         </div>
  //                       </div>
  //                     );
  //                   })}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //       <div className="w-full mt-20">
  //         <img src={mainBackground} alt="gdweh" className="" />
  //       </div>
  //       <div>
  //         <FooterLayout />
  //       </div>
  //     </div>
  //   </>
  // );
};
export default Home;
